__turbopack_context__.v({
  "product-tag": "q6pWjG_product-tag",
});
